/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to grant entitlement_distributor (MSP / grantor capability) from the platform only
 * @export
 * @interface GrantDistributorEntitlementRequest
 */
export interface GrantDistributorEntitlementRequest {
    /**
     * Tenant that will receive the distributor capability
     * @type {string}
     * @memberof GrantDistributorEntitlementRequest
     */
    tenantId: string;
    /**
     * Optional business reason (audit / support trail)
     * @type {string}
     * @memberof GrantDistributorEntitlementRequest
     */
    reason?: string;
    /**
     * Source label; default MANUAL_GRANT
     * @type {string}
     * @memberof GrantDistributorEntitlementRequest
     */
    source?: string;
    /**
     * Principal who granted (e.g. email). If omitted, set from session when available.
     * @type {string}
     * @memberof GrantDistributorEntitlementRequest
     */
    grantedBy?: string;
    /**
     * Quantity (seats or units)
     * @type {number}
     * @memberof GrantDistributorEntitlementRequest
     */
    quantity?: number;
    /**
     * Quantity limit (null = unlimited)
     * @type {number}
     * @memberof GrantDistributorEntitlementRequest
     */
    quantityLimit?: number;
    /**
     * Effective from (ISO-8601). Defaults to now.
     * @type {Date}
     * @memberof GrantDistributorEntitlementRequest
     */
    effectiveFrom?: Date;
    /**
     * Effective to (ISO-8601). Null = no expiry.
     * @type {Date}
     * @memberof GrantDistributorEntitlementRequest
     */
    effectiveTo?: Date;
}

/**
 * Check if a given object implements the GrantDistributorEntitlementRequest interface.
 */
export function instanceOfGrantDistributorEntitlementRequest(value: object): value is GrantDistributorEntitlementRequest {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function GrantDistributorEntitlementRequestFromJSON(json: any): GrantDistributorEntitlementRequest {
    return GrantDistributorEntitlementRequestFromJSONTyped(json, false);
}

export function GrantDistributorEntitlementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrantDistributorEntitlementRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'source': json['source'] == null ? undefined : json['source'],
        'grantedBy': json['grantedBy'] == null ? undefined : json['grantedBy'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'quantityLimit': json['quantityLimit'] == null ? undefined : json['quantityLimit'],
        'effectiveFrom': json['effectiveFrom'] == null ? undefined : (new Date(json['effectiveFrom'])),
        'effectiveTo': json['effectiveTo'] == null ? undefined : (new Date(json['effectiveTo'])),
    };
}

export function GrantDistributorEntitlementRequestToJSON(json: any): GrantDistributorEntitlementRequest {
    return GrantDistributorEntitlementRequestToJSONTyped(json, false);
}

export function GrantDistributorEntitlementRequestToJSONTyped(value?: GrantDistributorEntitlementRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'reason': value['reason'],
        'source': value['source'],
        'grantedBy': value['grantedBy'],
        'quantity': value['quantity'],
        'quantityLimit': value['quantityLimit'],
        'effectiveFrom': value['effectiveFrom'] == null ? undefined : ((value['effectiveFrom']).toISOString()),
        'effectiveTo': value['effectiveTo'] == null ? undefined : ((value['effectiveTo']).toISOString()),
    };
}

